/**
 * Direction C theme — flat colors, blue accent, floating-card layout.
 * Use via the ThemeProvider + useTheme() hook. Do not import this file
 * directly from components (read through the hook so users can toggle modes).
 */

export const darkTheme = {
  mode: "dark",

  // Surfaces
  bg: "#040506",        // outer canvas (between floating cards)
  bg2: "#0e0f11",
  surface: "#131417",   // card background (sidebar + main)
  surface2: "#1c1e22",  // nested cards (kpi, tables) + input field bg
  surface3: "#25272c",  // elevated bg (chip, hover)
  border: "#34363c",
  borderSoft: "#2a2c31",

  // Text
  text: "#f1f2f4",
  textDim: "#b0b3ba",
  textMute: "#7a7d84",

  // Accent (blue)
  brand: "#0957A2",
  brand2: "#2570BD",

  // Status colors (flat)
  green: "#4cb782",
  yellow: "#f2c94c",
  red: "#e05b59",
  blue: "#2570BD",
  teal: "#22d3ee",
  orange: "#f59e0b",

  // Avatar colors (flat — no gradients)
  avatarPalette: ["#2570BD", "#22d3ee", "#4cb782", "#f59e0b", "#e05b59", "#0957A2"],

  // Pill (magnetic active indicator)
  pillBg: "rgba(37,112,189,0.14)",
  pillBorder: "rgba(37,112,189,0.3)",
  pillBar: "#2570BD",

  // Radii
  radius: 6,
  radiusCard: 10,

  // Font stack (system)
  fontFamily: "System",
  fontMono: "Menlo",

  // Elevation (shadow tokens)
  shadow: "0 4px 20px -6px rgba(0,0,0,0.5)",
};

export const lightTheme = {
  mode: "light",

  bg: "#eaebee",
  bg2: "#ffffff",
  surface: "#ffffff",
  surface2: "#f6f6f7",
  surface3: "#ededee",
  border: "#e3e3e6",
  borderSoft: "#ededee",

  text: "#111113",
  textDim: "#5c5c62",
  textMute: "#8d8d94",

  brand: "#0957A2",
  brand2: "#2570BD",

  green: "#3d9a68",
  yellow: "#c49216",
  red: "#d14743",
  blue: "#0957A2",
  teal: "#0891b2",
  orange: "#ea580c",

  avatarPalette: ["#0957A2", "#0891b2", "#3d9a68", "#ea580c", "#d14743", "#2570BD"],

  pillBg: "rgba(9,87,162,0.10)",
  pillBorder: "rgba(9,87,162,0.28)",
  pillBar: "#0957A2",

  radius: 6,
  radiusCard: 10,

  fontFamily: "System",
  fontMono: "Menlo",

  shadow: "0 2px 8px rgba(15,24,39,0.06)",
};

export const themes = { dark: darkTheme, light: lightTheme };
